import React from "react";
import Header from "../components/Header";
import VisitorSearch from "../components/VisitorSearch";
import RandomVisitor from "../components/RandomVisitor";

function Visitor() {          
    return (
        <div>
            <Header/>
            <VisitorSearch/>
            <RandomVisitor/>
        </div>
    );
}

export default Visitor;